import { connect } from 'react-redux';
import { ApplicationState, CommanderThunkDispatch, Payment } from '@mews-commander/types';
import { getCurrentEnterpriseId } from '@mews-commander/core';
import { getPayment } from '@mews-commander/legacy-entities/src/ducks/payments';
import { isPaymentSelected, togglePaymentSelect } from '../../../../ducks/billItems';

interface StateProps {
    selected: boolean;
    payment: Payment;
}

interface DispatchProps {
    toggleSelect(): void;
}

interface OwnProps {
    scope: string;
    paymentId: string;
}

export const connectPaymentItem = connect<StateProps, DispatchProps, OwnProps, ApplicationState>(
    (state, { paymentId, scope }): StateProps => {
        const enterpriseId = getCurrentEnterpriseId();
        return {
            // @ts-expect-error $TSFixMeError: Argument of type '{ paymentId: string; scope: string; }' is not assignable to parameter of type '{ paymentId: string; }'...
            selected: isPaymentSelected(state, { paymentId, scope }),
            // @ts-expect-error
            payment: getPayment(state, { id: paymentId, enterpriseId }),
        };
    },
    (dispatch: CommanderThunkDispatch, { scope, paymentId }) => ({
        toggleSelect: () => dispatch(togglePaymentSelect(paymentId, scope)),
    })
);
